module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8blkj"))).then(() => parcelRequire('3a9aZ'));